import { useSelector } from 'react-redux';
import { selectOrgData } from 'selectors/orgData';

import { capitalize, getOrgGoalMeasurementTypes } from 'constants/helper';

import InputLabel from 'uiToolkitV1/InputLabel';
import { SelectV2 } from 'uiToolkitV1/SelectV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { InputLabelTextWithInfoTooltip } from './ManualKRTracking';

export const MeasureSelect = ({ measure, onChange, isReadOnly, hideSymbolText = false }) => {
  const orgData = useSelector(selectOrgData);
  const kRMeasurementTypes = getOrgGoalMeasurementTypes(orgData?.currency ?? null);

  const selectedMeasure = kRMeasurementTypes.find(({ code }) => code === measure);

  return (
    <SelectV2
      isReadOnly={isReadOnly}
      valueKey="code"
      menuItems={kRMeasurementTypes}
      selectedItem={selectedMeasure}
      renderControlItem={(menuItem) => {
        const label = hideSymbolText ? menuItem?.symbol : `${capitalize(menuItem?.code)} (${menuItem?.symbol})`;
        return (
          <TextBodyMedium color={menuItem?.code ? 'text.g1' : 'text.g2'}>
            {menuItem?.code ? label : 'Select'}
          </TextBodyMedium>
        );
      }}
      renderMenuItem={({ code, symbol }) => {
        const label = `${capitalize(code)} (${symbol})`;
        return <TextBodyMedium>{label}</TextBodyMedium>;
      }}
      onSelect={(menuItem) => onChange(menuItem.code)}
    />
  );
};

const OKRMeasure = ({ measure, onChange, isReadOnly, showInfoTooltip = false, showLabel = true, hideSymbolText }) => {
  const infoTooltip = showInfoTooltip ? <InputLabelTextWithInfoTooltip labelText="Measure" /> : 'Measure';
  const labelText = showLabel ? infoTooltip : '';
  return (
    <InputLabel
      labelText={labelText}
      containerProps={{
        className: 'measure-select-label',
      }}
    >
      <MeasureSelect measure={measure} onChange={onChange} isReadOnly={isReadOnly} hideSymbolText={hideSymbolText} />
    </InputLabel>
  );
};
export default OKRMeasure;
